'use strict';

// This code is almost identical to Scribe source code,
// except that we added a few more known block tags.

// See https://github.com/guardian/scribe/blob/master/src/plugins/core/formatters/html/enforce-p-elements.js

var _ = require('underscore');

var blockElementNames = ['P', 'DIV', 'BLOCKQUOTE', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'UL', 'OL', 'LI'];

function isBlockElement(node) {
  return _.contains(blockElementNames, node.nodeName);
}

/**
 * Wrap consecutive inline elements and text nodes in a P element.
 */
function wrapChildNodes(parentNode) {
  var groups = Array.prototype.reduce.call(parentNode.childNodes, function (accumulator, binChildNode) {
    function startNewGroup() {
      var newGroup = [binChildNode];
      accumulator.push(newGroup);
    }

    var group = _.last(accumulator);
    if (!group) {
      startNewGroup();
    } else {
      var isBlockGroup = isBlockElement(group[0]);
      if (isBlockGroup === isBlockElement(binChildNode)) {
        group.push(binChildNode);
      } else {
        startNewGroup();
      }
    }

    return accumulator;
  }, []);

  var consecutiveInlineElementsAndTextNodes = groups.filter(function (group) {
    var isBlockGroup = isBlockElement(group[0]);
    return !isBlockGroup;
  });

  consecutiveInlineElementsAndTextNodes.forEach(function (nodes) {
    var pElement = document.createElement('p');
    nodes[0].parentNode.insertBefore(pElement, nodes[0]);
    nodes.forEach(function (node) {
      pElement.appendChild(node);
    });
  });

  parentNode._isWrapped = true;
}

function enforcePElements(html) {
  var bin = document.createElement('div');
  bin.innerHTML = html;

  // Only wrap immediate children--unlike Scribe,
  // we don't care about <blockquote> contents.

  wrapChildNodes(bin);

  return bin.innerHTML;
}

module.exports = enforcePElements;


/** WEBPACK FOOTER **
 ** ./utils/enforcePElements.js
 **/